import nbaProjImg from '../../assets/Projects/_featured/01-NBA-Logo.jpg';
import fifaProjImg from '../../assets/Projects/_featured/02-FIFA-Logo2.png';
import cdsProjImg from '../../assets/Projects/_featured/CDS-2023.jpg';
import mfProjImg from '../../assets/Projects/_featured/04-MomentFactory-Logo.jpg';
import mtlChProjImg from '../../assets/Projects/_featured/05-MontrealCanadiens-Logo.jpg';
import microsoftImg from '../../assets/Projects/_featured/06-microsoft2023.jpg';
import masterCardProjImg from '../../assets/Projects/_featured/07-Mastercard-BlackLogo.jpg';
import googleProjImg from '../../assets/Projects/_featured/08-Google-Logo.png';
import bulgariProjImg from '../../assets/Projects/_featured/09-Bulgari-Logo.png';
import grandBalProjImg from '../../assets/Projects/_featured/69-Grandbaldesvins-cœurs.jpg';
import mineraProjImg from '../../assets/Projects/_featured/51-MineraSanta-Maria.jpg';
import bravuraProjImg from '../../assets/Projects/_featured/46-CDS-Bravura.jpg';
import g7projImg from '../../assets/Projects/_featured/44-G72018.jpg';
import timHortonsImg2 from '../../assets/Projects/_featured/36-TimHortons.jpg';
import masterCardProjImg2 from '../../assets/Projects/_featured/28-2-mastercard.jpg';
import michaelEastonProjImg from '../../assets/Projects/_featured/27-MichaelEaston.jpg';
import cameronImg from '../../assets/Projects/_featured/25-paramount.jpg';
import beijingImg from '../../assets/Projects/_featured/31-Beijing.jpg';
import irisImg from '../../assets/Projects/_featured/26-iris.jpg';
import alibabaImg from '../../assets/Projects/_featured/30-Alibaba.jpg';
import fosunImg from '../../assets/Projects/_featured/40-Fosun.jpg';
import situImg from '../../assets/Projects/_featured/49-SituStudio.jpg';
import tianguisImg from '../../assets/Projects/_featured/50-MexicoTourism.jpg';
import jnfImg from '../../assets/Projects/_featured/73-JNF.jpg';
import doArtImg from '../../assets/Projects/_featured/59-DoArtFoundation.jpg';
import mobiliaImg from '../../assets/Projects/_featured/65-Mobilia50thBirthdayCampaign.jpg';
import deferlImg from '../../assets/Projects/_featured/67-ProductionsDeferlantes.jpg';
import biteImg from '../../assets/Projects/_featured/68-BiteSizeEntertainement.jpg';
import heliDroneProjImg from '../../assets/Projects/_featured/71-helidrone.png';
import romyImg from '../../assets/Projects/_featured/72-Romy.jpg';
import mscImg from '../../assets/Projects/_featured/22-MSCCruises-Logo.jpg';
import peiImg from '../../assets/Projects/_featured/74-PrinceEdwardIsland-Logo.jpg';
import salesForceImg from '../../assets/Projects/_featured/10-SalesForce-Logo3.png';
import Andorra2016ProjImg from '../../assets/Projects/Andorra2016.jpg';
import MasterCard2 from '../../assets/Projects/_featured/07-Mastercard-BlackLogo.jpg';
import Andorra2015ProjImg from '../../assets/Projects/Andorra2015.jpg';
import Andorra2014ProjImg from '../../assets/Projects/Andorra2014.jpg';
import deloitteProjImg from '../../assets/Projects/_featured/62-Deloitte.jpg';
import rexelProjImg from '../../assets/Projects/_featured/39-Rexel.jpg';
import tpgProjImg from '../../assets/Projects/_featured/38-TPG.jpg';
import ivanhoeProjImg from '../../assets/Projects/_featured/52-IvanhoeCambridge.jpg';
import skoda4ProjImg from '../../assets/Projects/_featured/17-SkodaAuto-Logo2.jpg';
import clubMedProjImg from '../../assets/Projects/_featured/42-ClubMed.jpg';
import hiltonProjImg from '../../assets/Projects/_featured/43-Hilton.jpg';
import sbm3ProjImg from '../../assets/Projects/_featured/53-MonteCarlo.jpg';
import oneDropProjImg from '../../assets/Projects/_featured/OneDrop.jpg';
import wefProjImg from '../../assets/Projects/_featured/45-WEF.jpg';
import sunLifeProjImg from '../../assets/Projects/_featured/13-SunLife-Logo.jpg';
import cnProjImg from '../../assets/Projects/_featured/34-CN.jpg';
import c2ProjImg from '../../assets/Projects/_featured/61-C2-Logo2.jpg';
import dubaiProjImg from '../../assets/Projects/_featured/12-TheDubaiMall-Logo.jpg';
import ydlmProjImg from '../../assets/Projects/_featured/63-MarioCyr.jpg';
import boccaProjImg from '../../assets/Projects/_featured/41-Monaco2019.jpg';
import nicolasProjImg from '../../assets/Projects/_featured/37-ChampagneNicolas.jpg';
import astanaProjImg from '../../assets/Projects/_featured/47-Astana.jpg';
import laxProjImg from '../../assets/Projects/_featured/20-LAX.jpg';
import mjProjImg from '../../assets/Projects/_featured/23-Michael.jpg';

import csaProjImg from '../../assets/Projects/_featured/19-CSA.jpg';
import bakuProjImg from '../../assets/Projects/4-Stadium-BAKU-Benjamin-Proulx-Mathers-Christian-Lagueux-YUL-MUSIC-Montreal-Composer.jpg';
import q50ProjImg from '../../assets/Projects/_featured/16-InifinityCar-Logo.jpg';
import sapProjImg from '../../assets/Projects/_featured/14-SAP-Logo.jpg';
import biionProjImg from '../../assets/Projects/Biion-2-Benjamin-Proulx-Mathers-Christian-Lagueux-YUL-MUSIC-Montreal-Composer.jpg';
import bomb3ProjImg from '../../assets/Projects/_featured/18-bombardier-plane.jpg';

import cocProjImg from '../../assets/Projects/_featured/33-CoC.jpg';
import courchevelProjImg from '../../assets/Projects/_featured/courchevel-night-1-721x471.jpg';
import scJohnsonProjImg from '../../assets/Projects/_featured/32-SCJ.jpg';
import magnum2ProjImg from '../../assets/Projects/_featured/35-magnum.jpg';
import poppinsProjImg from '../../assets/Projects/_featured/24-MaryPop.jpg';
import lotoQuebecProjImg from '../../assets/Projects/_featured/64-LotoQuebec.jpg';
import sidLeeProjImg from '../../assets/Projects/_featured/66-SidLee.jpg';
import eyProjImg from '../../assets/Projects/_featured/15-Ernst&Young-Logo.jpg';
import eyProjImg2 from '../../assets/Projects/EY-MainRoom.jpg';
import CarnivalCruisesProjImg from '../../assets/Projects/_featured/21-Carnival.jpg';
import tMobileProjImg from '../../assets/Projects/_featured/11-T-Mobile-Logo-2.jpg';
import ZacBrownProjImg from '../../assets/Projects/_featured/24-5-ZacBrownBand-NewLogo.jpg';
import timeProjImg from '../../assets/Projects/_featured/29-TimeEntertainment-Logo.jpg';
import trioOrangeProjImg from '../../assets/Projects/_featured/70-TrioOrange.jpg';
import trainProjImg from '../../assets/Projects/_featured/60-YULMUSIC-TraintheCircusBeyond.jpg';
import oneDropProjImg2 from '../../assets/Projects/_featured/58-OneDropOneNight.jpg';
import monaco2018ProjImg2 from '../../assets/Projects/_featured/41-5-Monaco2018.jpg';

// TODO: lighthouse
// TODO: lazyload some stuff ? make sure site does not try to get all images before they are needed
// TODO: embed vimeo

export const projectsData = [
    {
        id: 1,
        title: 'NBA',
        year: 2016,
        location: 'Toronto, Canada',
        subtitle: 'All-Star Weekend',
        detailedSubtitle:
            'The NBA All-Star Pregame Show, televised in over 200 countries',
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: nbaProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/157210250' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 2,
        title: 'FIFA',
        year: 2012,
        location: 'Baku, Azerbaijan',
        subtitle: 'U-17 World Cup',
        detailedSubtitle:
            'FIFA U-17 World Cup Opening Ceremony also starring Jennifer Lopez',
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: fifaProjImg,
        extraMedia: [{ type: 'img', data: bakuProjImg }],
    },
    {
        id: 3,
        // title: 'Vision by Cirque du Soleil',
        title: 'Cirque du Soleil',
        // year: 2016,
        year: 2014 - 2015 - 2016,
        location: 'Andorra',
        subtitle: 'Andorra',
        detailedSubtitle: 'Mater Natura - Storia - Vision',
        categoriesText:
            'Music Composition - Music Arrangement - Music Producing - Sound Design - Mixing',
        bgImg: cdsProjImg,
        // bgImg: Andorra2016ProjImg,
        // extraMedia: [{ type: 'video', data: { src: '' } }],
        extraMedia: [
            { type: 'img', data: Andorra2016ProjImg },
            { type: 'img', data: Andorra2015ProjImg },
            { type: 'img', data: Andorra2014ProjImg },
        ],
    },
    {
        id: 4,
        title: 'Moment Factory',
        altTitle: 'Moment Factory',
        year: 2017,
        location: 'Hangzhou, China',
        subtitle: 'Songcheng Theme Park',
        detailedSubtitle:
            'Songcheng, one of the ten biggest theme park groups in the world, has asked Moment Factory to design a multimedia attraction that will put their park in Hangzhou at the forefront of the entertainment world',
        categoriesText:
            'Music Composition - Sound Design - 360-Degree Spatial Audio - Mixing',
        bgImg: mfProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/233866505' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 5,
        title: 'Montreal Canadiens',
        year: 2006,
        location: 'Montreal, Canada',
        subtitle: 'Playoff Pregame Soundtrack',
        detailedSubtitle:
            'Playoff Pregame Soundtrack and live performances',
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing - Musical Direction ',
        bgImg: mtlChProjImg,
    },
    {
        id: 6,
        title: 'Microsoft',
        year: 2014,
        location: 'Montreal, Canada',
        subtitle: 'One Drop Foundation',
        detailedSubtitle:
            'Microsoft and One Drop are teaming up to promote food security',
        categoriesText: 'Music Composition - Music Producing - Mixing',
        // bgImg: oneDropProjImg,
        bgImg: microsoftImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/133273251' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 29,
        title: 'Time Entertainment',
        year: 2022,
        location: 'Saudi Arabia',
        subtitle: 'Diriyah Season Opening Ceremony',
        detailedSubtitle: undefined,
        categoriesText: 'Music Composition - Music Producing - Mixing',
        bgImg: timeProjImg,
    },
    {
        id: 70,
        title: 'Trio Orange',
        altTitle: 'Trio Orange - Hôtels et restos',
        year: 2012,
        location: 'Montreal, Quebec, Remote',
        subtitle: "Hôtels et restos d'exception",
        detailedSubtitle: "Hôtels et restos d'exception TV Show",
        categoriesText: 'Music Composition - Sound Design - Mixing',
        bgImg: trioOrangeProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/96963215',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 70.5,
        title: 'Trio Orange',
        altTitle: 'Trio Orange - En pays maya',
        year: 2012,
        location: 'Montreal, Quebec, Remote',
        subtitle: 'En pays maya',
        detailedSubtitle: 'Geneviève Borne au Mexique “En pays maya” TV Show',
        categoriesText: 'Music Composition - Sound Design - Mixing',
        bgImg: trioOrangeProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/89807140',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 71,
        title: 'Heli Drone Images',
        year: 2022,
        location: 'Bahamas',
        subtitle: "Filming for TV Show Jeter l'ancre",
        detailedSubtitle:
            "Heli Drone Images - In the Bahamas filming for TV Show Jeter l'ancre",
        categoriesText: 'Music Composition - Mixing',
        bgImg: heliDroneProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/814345333?h=1ed63afd37',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 61,
        title: 'C2 Agency',
        year: 2022,
        location: 'Montréal, Québec, Canada',
        detailedSubtitle: undefined,
        categoriesText: 'Music Composition - Music Producing - Mixing',
        bgImg: c2ProjImg,
    },
    {
        id: 15,
        title: 'Ernst & Young',
        year: 2022,
        location: 'Chicago, United States',
        subtitle: 'Innovation Realized Global Summit',
        detailedSubtitle:
            'Ernst & Young - Innovation Realized Global Summit',
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: eyProjImg,
        extraMedia: [{ type: 'img', data: eyProjImg2 }],
    },
    {
        id: 7,
        title: 'Mastercard',
        altTitle: 'Mastercard',
        year: 2022,
        location: 'North America Campaign',
        subtitle: 'Cirque du Soleil Anthem',
        detailedSubtitle:
            'Multi-year deal with Cirque du Soleil Entertainment Group to be the official partner of Cirque du Soleil Touring Shows in Canada',
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: masterCardProjImg,
        extraMedia: [{ type: 'img', data: MasterCard2 }],
        hideLogo: true,
    },
    {
        id: 69,
        title: 'Grand bal des vins-cœurs and Cirque du Soleil',
        altTitle: 'Grand bal des vins-cœurs',
        year: '2021 - 2019 - 2015 - 2009',
        location: 'Montreal, Canada',
        subtitle: 'Cirque du Soleil - Grand bal des vins-cœurs - Montreal',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: grandBalProjImg,
    },
    {
        id: 21,
        title: 'P&O Cruises Onboard shows',
        year: 2021,
        location: 'London, United Kingdom',
        subtitle: 'Carnival UK - P&O Cruises & Cunard - IONA ',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: CarnivalCruisesProjImg,
        // extraMedia: [
        //     { type: 'img', data: iona2ProjImg },
        //     { type: 'img', data: iona3ProjImg },
        // ],
    },
    {
        id: 13,
        title: 'Sunlife',
        year: 2021,
        location: 'United States',
        subtitle: 'Promotion Video',
        detailedSubtitle: 'Sunlife Promotion Video',
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: sunLifeProjImg,
    },
    {
        id: 11,
        title: 'T-Mobile',
        year: 2020,
        location: 'United States',
        subtitle: 'Holiday Video',
        detailedSubtitle: 'T-Mobile Holiday Video',
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: tMobileProjImg,
    },
    {
        id: 14,
        title: 'SAP',
        // altTitle: 'SAP Convention',
        year: '2020, 2018, 2017, 2015, 2013',
        location: 'Various locations, Worldwide',
        subtitle: 'Worldwide Conventions',
        detailedSubtitle: 'The SAP Conventions',
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: sapProjImg,
    },
    {
        id: 37,
        title: 'Champagne Nicolas Feuillatte',
        year: 2020,
        location: 'France',
        subtitle:
            'Artistic performance for the Champagne Nicolas Feuillatte vip clients',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: nicolasProjImg,
    },
    {
        id: 45,
        title: 'World Economic Forum',
        year: '2020, 2019, 2017, 2016',
        location: 'Switzerland',
        subtitle: 'Artistic performance for the BMO vip clients - Multi-year deal',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: wefProjImg,
    },
    {
        id: 28,
        title: 'Mastercard / Smart Summit',
        year: 2019,
        location: 'Seattle, United States',
        subtitle: 'Seattle Mastercard Smart Summit',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: masterCardProjImg,
    },
    // {
    //     id: 71.5,
    //     title: 'Heli Drone Images',
    //     year: 2019,
    //     location: 'Montreal, Canada',
    //     subtitle: 'Heli Drone Images - Demo-Reel',
    //     detailedSubtitle: undefined,
    //     categoriesText: 'Music Composition - Mixing',
    //     // bgImg: masterCardProjImg,
    //     // extraMedia: [
    //     //     {
    //     //         type: 'video',
    //     //         data: {
    //     //             src: 'https://player.vimeo.com/video/814345411',
    //     //         },
    //     //     },
    //     // ],
    // },
    {
        id: 41,
        title: 'Monte-Carlo SBM / Monte-Carlo Sporting Summer Festival',
        altTitle: 'Monte-Carlo SBM (2019)',
        year: 2019,
        location: 'Monaco',
        subtitle:
            'Cirque du Soleil Events + Experiences brought Cirque du Soleil’s acclaimed brand of theatrical entertainment to Monaco for an exclusive, special performance at the Monte-Carlo Sporting Summer Festival',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - On site supervision',
        bgImg: boccaProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/808655403?h=aa1ebea41d',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 34,
        title: '100th Anniversary of CN Rail',
        year: 2019,
        location: 'North America Tour',
        subtitle:
            'To commemorate this very special milestone, CN have a number of events planned to honour is rich railroading history and future.',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Mixing',
        bgImg: cnProjImg,
    },
    {
        id: 52,
        title: 'Ivanhoe Cambridge',
        year: 2019,
        location: 'Canada',
        subtitle:
            'Speech by the president of Cirque du Soleil, Daniel Lamarre, and a Cirque du Soleil performance',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: ivanhoeProjImg,
    },
    // {
    //     id: 17,
    //     title: 'Skoda Auto',
    //     altTitle: 'Skoda Auto (2019)',
    //     year: 2019,
    //     location: 'Spain',
    //     subtitle: 'Cirque du Soleil’s Special Event',
    //     detailedSubtitle: undefined,
    //     categoriesText:
    //         'Music Producing - Music Arrangement - Sound Design - Mixing',
    //     bgImg: skoda4ProjImg,
    // },
    {
        id: 30,
        title: 'Alibaba Single Gala',
        year: 2018,
        location: 'Shanghai, China',
        subtitle:
            "Alibaba's Singles Day is a massive 24-hour shopping extravaganza unlike anything else in the world. In 2018, the event kicked off with a four-hour gala featuring numerous celebrities, including the model Miranda Kerr, the singer Mariah Carey and Cirque du Soleil.",
        detailedSubtitle:
            "The gala is just one way that Alibaba brings drama to online shopping. It's a crucial shot of hectic energy as historic shopping bonanzas like Black Friday lag behind. The Viewers were able to experience the gala live via Youku, as well as across China on two major Chinese TV stations. (500 Millions Viewers)",
        categoriesText: 'Music Composition - Sound Design - Mixing',
        bgImg: alibabaImg,
    },
    {
        id: 31,
        title: 'Beijing Parkview Green Inauguration',
        altTitle: 'Beijing Parkview',
        year: 2013,
        location: 'Beijing, China',
        subtitle: 'Artistic performance for the Parkview Green inauguration.',
        detailedSubtitle:
            'Parkview Green is an intelligent building that sets new standards in both form and function. Located in the heart of Beijing‘s CBD (Central Business District), Parkview Green is a potent symbol of a new way of thinking',
        categoriesText: 'Music Composer - Music Producer - Mixer',
        bgImg: beijingImg,
    },
    {
        id: 41.5,
        title: 'Monte-Carlo SBM / Monte-Carlo Sporting Summer Festival',
        altTitle: 'Monte-Carlo SBM (2018)',
        year: 2018,
        location: 'Monaco',
        subtitle:
            "Cirque du Soleil Events + Experiences brought Cirque du Soleil's acclaimed brand of theatrical entertainment to Monaco for an exclusive, special performance at the Monte-Carlo Sporting Summer Festival",
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - On site supervision',
        bgImg: monaco2018ProjImg2,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/808652228?h=35840d87b4',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 72,
        title: 'Romy & Aksel',
        year: 2018,
        location: 'Monaco',
        subtitle: 'Romy & Aksel Web Campaign',
        detailedSubtitle: undefined,
        categoriesText: 'Music Composition - Sound Design - Mixing',
        bgImg: romyImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/814690219',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 44,
        title: 'G7 Summit and Cirque du Soleil Entertainment Group',
        altTitle: 'G7 & CDS Entertainment Group',
        year: 2018,
        location: 'Quebec, Canada',
        subtitle:
            'The 44th G7 summit was held on 8-9 June 2018, in La Malbaie, Quebec, Canada. This was the sixth time since 1981 that Canada has hosted the meetings',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: g7projImg,
    },
    {
        id: 54,
        title: 'Cirque du Soleil Entertainment Group Partners Summit',
        altTitle: 'CDS Entertainment Group',
        year: 2018,
        location: 'Quebec, Canada',
        subtitle: undefined,
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: cdsProjImg,
    },
    {
        id: 50,
        title: 'Tourism Tianguis of Mexico',
        year: 2018,
        location: 'Mazatlén, Mexico',
        subtitle:
            'The Opening Ceremony of the Tourism Tianguis of Mexico (New Mexico Tourism Department)',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: tianguisImg,
    },
    {
        id: 28.2,
        title: 'Mastercard',
        year: 2018,
        location: 'Toronto, Canada',
        subtitle: 'Mastercard Convention',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: masterCardProjImg2,
    },
    {
        id: 68,
        title: 'Bite Size Entertainment',
        year: 2017,
        location: 'Montreal, Canada',
        subtitle: 'Merry Montreal Audio Branding',
        detailedSubtitle: undefined,
        categoriesText: 'Music Composition - Sound Design - Mixing ',
        bgImg: biteImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/196015834',
                },
            },
        ],
        hideLogo: true,
    },
    // {
    //     id: 69,
    //     title: 'Grand bal des vins-cœurs',
    //     year: 2017,
    //     location: 'Montreal, Canada',
    //     subtitle: 'Cirque du Soleil',
    //     detailedSubtitle: 'Grand bal des vins-cœurs and Cirque du Soleil',
    //     categoriesText: 'Music Composition - Sound Design - Mixing ',
    //     bgImg: biteImg,
    // },
    {
        id: 8,
        title: 'Google',
        year: 2017,
        location: 'Brussels, Belgium',
        subtitle: 'Europe on Stage',
        detailedSubtitle:
            'A Cirque du Soleil special event made for the Google private event called Europe on Stage',
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: googleProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/204619615' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 17.2,
        title: 'Skoda Auto',
        altTitle: 'Skoda Auto (2017)',
        year: 2017,
        location: 'Spain',
        subtitle: 'Vision E Concept Launch',
        detailedSubtitle:
            'Skoda Auto, for the launch of the new Skoda Vision E Concept',
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: skoda4ProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/241883171?h=21ce290877',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 38,
        title: 'TPG Texas Pacific Group',
        year: 2017,
        location: 'Phoenix, United States',
        subtitle:
            'TPG Phoenix Convention. Texas Pacific Group is one of the largest private equity firms in the world. The company invests in a wide range of sectors, including media and telecommunications',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: tpgProjImg,
    },
    {
        id: 63,
        title: 'Mario Cyr / Les yeux de la mer (Productions J)',
        altTitle: 'Mario Cyr / Les yeux de la mer',
        year: 2017,
        location: 'Canada and France',
        subtitle:
            'Mario Cyr is an internationally renowned expedition leader for Arctic and Antarctic missions, a cold-water diving expert and a world-class cinematographer.',
        detailedSubtitle:
            'Mario Cyr is an internationally renowned expedition leader for Arctic and Antarctic missions, a cold-water diving expert and a world-class cinematographer. He has participated in more than 150 films for broadcasters such as National Geographic, Discovery Channel, the BBC, IMAX 3D, Disney Productions, the CBC and David Suzuki, la Société Cousteau, France 2, Arte and NHK Japan',
        categoriesText: 'Music Composition - Sound Design - Mixing',
        bgImg: ydlmProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/240054639?h=20dea6340e',
                },
            },
            // { type: 'img', data: ydlm2ProjImg },
            // { type: 'video', data: { src: '' } }, // la descente, besoin de password ?
        ],
        hideLogo: true,
    },
    {
        id: 12,
        title: 'The Dubai Mall',
        year: 2016,
        location: 'Dubai, United Arab Emirates',
        subtitle:
            'A Cirque du Soleil presentation, specially designed for The Dubai Mall Level Kids opening',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: dubaiProjImg,
    },
    {
        id: 46,
        title: 'Bravura by Cirque du Soleil',
        year: 2016,
        location: 'Mumbai, India',
        subtitle: undefined,
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Arrangement - Music Producing - Sound Design - Mixing',
        bgImg: bravuraProjImg,
    },
    {
        id: 73,
        title: 'Jewish National Foundation',
        year: 2016,
        location: 'Montreal, Canada',
        subtitle: 'Jewish National Foundation Gala',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: jnfImg,
    },
    // {
    //     id: 4630,
    //     title: 'Scalada by Cirque du Soleil',
    //     year: 2015,
    //     location: 'Andorra',
    //     subtitle: undefined,
    //     detailedSubtitle: undefined,
    //     categoriesText:
    //         'Music Composition - Music Arrangement - Music Producing - Sound Design - Mixing',
    //     bgImg: Andorra2015ProjImg,
    // },
    {
        id: 25,
        title: 'Cirque du Soleil, James Cameron and Andrew Adamson',
        altTitle: 'CDS, J. Cameron and A. Adamson',
        year: 2015,
        location: 'Worldwide',
        subtitle: 'Worlds Away 3d Movie Trailer',
        detailedSubtitle: undefined,
        categoriesText: 'Post-production',
        bgImg: cameronImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/808710028' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 39,
        title: 'Rexel',
        year: 2016,
        location: 'United States',
        subtitle: 'Rexel Summit',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: rexelProjImg,
    },

    {
        id: 24,
        title: 'Mary Poppins Musical / Just For Laughs Festival I Festival Juste pour rire',
        altTitle: 'Mary Poppins Musical',
        year: 2016,
        location: 'Montreal, Canada',
        subtitle: undefined,
        detailedSubtitle: undefined,
        categoriesText:
            'Additional Music Producing - Additional Music Arrangement - Mixing',
        bgImg: poppinsProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/171801726' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 24.5,
        title: 'Zac Brown Band',
        altTitle: 'Zac Brown Band',
        year: 2014,
        location: 'Los Angeles, USA',
        subtitle: undefined,
        detailedSubtitle:
            'Opening Soundtrack for the Zac Brown Band’s Great American Road Trip Tour',
        categoriesText: 'Music Composition - Music Producing - Mixing',
        bgImg: ZacBrownProjImg,
        // hideLogo: true,
    },
    {
        id: 65,
        title: 'Mobilia',
        altTitle: undefined,
        year: 2016,
        location: 'Montreal, Canada',
        subtitle: 'Mobilia - Mobilia 50th Birthday Campaign',
        detailedSubtitle: undefined,
        categoriesText: 'Music Composition - Sound Design - Mixing',
        bgImg: mobiliaImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/157359901' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 9,
        title: 'Bulgari',
        year: 2016,
        location: 'Tokyo, Japan',
        subtitle: 'Collection Lauch - Tokyo',
        detailedSubtitle:
            'Launch of a new collection for the 50 most prestigious Bulgari clients',
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: bulgariProjImg,
    },
    {
        id: 10,
        title: 'Sales Force',
        year: 2015,
        location: 'Toronto, Canada',
        subtitle: 'Promotion Event - Toronto',
        detailedSubtitle: 'The Toronto Sales Force promotion event',
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: salesForceImg,
    },
    {
        id: 67,
        title: 'Productions Déferlantes',
        year: 2016,
        location: 'Montreal, Canada',
        subtitle: 'Productions Déferlantes Audio Branding',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: deferlImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/152183951' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 40,
        title: 'Fosun',
        year: 2015,
        location: 'China',
        subtitle: 'Fosun SUmmit',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: fosunImg,
    },
    {
        id: 59,
        title: 'Do Art Foundation',
        year: 2015,
        location: 'Montreal, Canada ',
        subtitle: 'Herakut in Montreal for the Giant Story Book',
        detailedSubtitle: undefined,
        categoriesText: 'Music Composition - Sound Design - Mixing',
        bgImg: doArtImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/89856619',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 60,
        title: 'YUL MUSIC',
        year: 2010,
        location: 'Montreal, Canada ',
        subtitle: 'Train the Circus Beyond',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: trainProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/245541148',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 49,
        title: 'SITU Studio NYC',
        year: 2015,
        location: 'New York, USA',
        subtitle: 'New York Hall of Science, Amplitude Video Project',
        detailedSubtitle:
            'The Great Hall, also known as the Cathedral of Science, is a 7,000 square foot exhibition space enclosed by a 100 foot tall scalloped dalle de verre façade, where 5400 inch-thick panels of cobalt blue glass are cast into concrete tiles and then set into cast-in-place concrete cells. In order to access each of the tiles, an elaborate scaffold has been constructed in the Great Hall, echoing the undulation of the concrete walls with a matrix of metal pipes and wooden planks',
        categoriesText: 'Music Composition - Sound Design - Mixing',
        bgImg: situImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/151970616',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 66,
        title: 'Sid Lee',
        year: 2015,
        location: 'Montreal, Canada',
        subtitle: 'Sid Lee Entertainment REEL ',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: sidLeeProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/128518658?h=caa4ee603b&title=0&byline=0',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 18,
        title: 'Bombardier Aerospace',
        altTitle: 'Bombardier',
        year: 2015,
        location: 'Geneva, Switzerland',
        subtitle: 'Global 7000 Reveal',
        detailedSubtitle:
            'Bombardier unveils the Global 7000 mock-up at EBACE - The largest in business aviation',
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: bomb3ProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/209994952' },
            },
            // { type: 'img', data: bomb6ProjImg },
            // { type: 'img', data: bomb7ProjImg },
        ],
        hideLogo: true,
    },
    {
        id: 48,
        title: 'Biion Footwear',
        year: 2015,
        location: 'Toronto, Canada',
        subtitle: 'Biion Footwear Web Campaign',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: biionProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/131800532' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 33,
        title: 'Canadian Olympic Committee',
        year: 2015,
        location: 'Montreal, Canada',
        subtitle: 'Canadian Olympic Excellence Day',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: cocProjImg,
    },
    {
        id: 22,
        title: 'MSC Cruises',
        year: 2015,
        location: 'Geneva, Switzerland',
        subtitle: 'Geneva MSC Cruises Conference',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: mscImg,
    },
    {
        id: 53.1,
        title: 'Monte-Carlo SBM (Société des Bains de Mer) ',
        altTitle: 'Monte-Carlo SBM (2015)',
        year: 2015,
        location: 'Monaco',
        subtitle: 'Monaco World Entrepreneur of the Year',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: sbm3ProjImg,
    },
    // {
    //     id: 4410,
    //     title: 'Microsoft One Drop / The One Drop of Life app ',
    //     altTitle: 'Microsoft One Drop App',
    //     year: 2014,
    //     location: 'Worldwide',
    //     subtitle: 'Microsoft One Drop / The One Drop of Life app',
    //     detailedSubtitle: undefined,
    //     categoriesText: 'Music Composition - Music Producing - Mixing',
    //     bgImg: oneDropProjImg,
    // },
    {
        id: 64,
        title: 'Loto-Québec',
        year: 2014,
        location: 'Montreal, Canada',
        subtitle:
            'Nucleus - Multimedia-installation at Festival Montreal en Lumière',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: lotoQuebecProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/90028196' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 32,
        title: 'SC Johnson',
        year: 2014,
        location: 'New York City, United States',
        subtitle: 'Glade - NYC Stunt and North America Television Campaign',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: scJohnsonProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/116108158',
                },
            },
        ],
        hideLogo: true,
    },
    // {
    //     id: 4410,
    //     title: 'Microsoft One Drop / The One Drop of Life app ',
    //     altTitle: 'Microsoft One Drop App',
    //     year: 2014,
    //     location: 'Worldwide',
    //     subtitle: 'Microsoft One Drop / The One Drop of Life app',
    //     detailedSubtitle: undefined,
    //     categoriesText: 'Music Composition - Music Producing - Mixing',
    //     bgImg: oneDropProjImg,
    // },
    {
        id: 20,
        title: 'LAX Airport',
        year: 2014,
        location: 'Los Angeles, United States',
        subtitle: 'Moment Factory Installation',
        detailedSubtitle:
            'LAX Tom Bradley International Terminal. The Largest Immersive Multimedia Installation',
        categoriesText: 'Music Composition - Music Producing - Mixing',
        bgImg: laxProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/214673610' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 36,
        title: 'Tim Hortons 50th birthday ',
        year: 2014,
        location: 'Toronto, Canada',
        subtitle:
            'Cirque du Soleil artistic performance for the 50th birthday of Tim Hortons',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: timHortonsImg2,
        // extraMedia: [
        //     {
        //         type: 'img',
        //         data: timProjImg,
        //     },
        // ],
    },
    {
        id: 58,
        title: 'One Night for One Drop',
        year: 2014,
        location: 'Las Vegas, United States',
        subtitle: 'One Night for One Drop',
        detailedSubtitle: undefined,
        categoriesText: 'Music Composition - Music Producing - Mixing',
        bgImg: oneDropProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/136266499?h=4333a17910',
                },
            },
            // {
            //     type: 'video',
            //     data: {
            //         src: 'https://player.vimeo.com/video/89806963?h=7284023a10',
            //     },
            // },
        ],
        hideLogo: true,
    },
    {
        id: 43,
        title: 'Hilton Hotels & Resorts',
        year: 2014,
        location: 'Orlando, United States',
        subtitle: 'Hilton Orlando',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: hiltonProjImg,
    },
    {
        id: 42,
        title: 'Club Med',
        year: 2014,
        location: 'Punta Cana, Dominican Republic',
        subtitle: 'Club Med Promotion',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Mixing ',
        bgImg: clubMedProjImg,
    },
    {
        id: 53.2,
        title: 'Monte-Carlo SBM (Société des Bains de Mer)',
        altTitle: 'Monte-Carlo SBM (2014)',
        year: 2014,
        location: 'Monaco',
        subtitle: 'Monaco World Entrepreneur of the Year',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: sbm3ProjImg,
    },
    {
        id: 35,
        title: 'Magnum Pleasure Store',
        year: 2013,
        location: 'Toronto, Canada',
        subtitle: 'Launch of the Toronto Magnum Pleasure Store',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: magnum2ProjImg,
    },
    {
        id: 16,
        title: 'Infinity',
        year: 2013,
        location: 'Detroit, United States',
        subtitle: 'Q50 Global Reveal',
        detailedSubtitle: 'Infinity for the Q50 Global Reveal',
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: q50ProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/134233531',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 55.5,
        title: 'Cirque du Soleil Experiences',
        year: 2013,
        location: 'Montreal, Canada',
        subtitle:
            'Paul Desmarais’s granddaughter marries a Belgian prince in Montreal ',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: cdsProjImg,
    },
    {
        id: 57,
        title: 'One Drop Foundation',
        year: 2014,
        location: 'Worldwide',
        subtitle: 'Transforming Water Into Action Campaign',
        detailedSubtitle: undefined,
        categoriesText: 'Music Composition - Music Producing - Mixing',
        bgImg: oneDropProjImg2,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/122764253',
                },
            },
        ],
    },
    {
        id: 47,
        title: 'Cirque du Soleil',
        year: 2012,
        location: 'Astana City, Kazakhstan',
        subtitle: 'Astana City Celebration in Kazakhstan',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing',
        bgImg: astanaProjImg,
    },
    {
        id: 62,
        title: 'Deloitte',
        year: 2012,
        location: 'Vancouver, Canada',
        subtitle: 'Deloitte Convention',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: deloitteProjImg,
    },
    // {
    //     id: 4080,
    //     title: 'Mater Natura by Cirque du Soleil',
    //     altTitle: 'Mater Natura',
    //     year: 2014,
    //     location: 'Andorra',
    //     detailedSubtitle: undefined,
    //     categoriesText:
    //         'Music Composition - Music Arrangement - Music Producing - Sound Design - Mixing',
    //     bgImg: materNaturaProjImg,
    // },
    {
        id: 51,
        title: 'Minera Santa-Maria 150th Anniversary',
        altTitle: 'Minera Santa-Maria 150th',
        year: 2014,
        location: 'Mexico City, Mexico',
        subtitle:
            'A Cirque du Soleil special event for the Minera Santa-Maria 150th Anniversary',
        detailedSubtitle: undefined,
        categoriesText: 'Music Music Producing - Mixing',
        bgImg: mineraProjImg,
    },
    {
        id: 23,
        title: 'Michael Jackson - The Immortal World Tour by Cirque du Soleil',
        altTitle: 'Michael Jackson - The Immortal',
        year: 2011,
        location: 'Montréal, Canada',
        subtitle: 'Flash Mob Stunts, directed by Travis Payne',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing',
        bgImg: mjProjImg,
    },
    {
        id: 55,
        title: 'Victor Pinchuk 50th anniversary',
        altTitle: 'Victor Pinchuk 50th',
        year: 2010,
        location: 'France',
        subtitle:
            'A custom made Cirque du Soleil show, also starring Christina Aguilera and Monegasque super chef Alain Ducasse for Victor Pinchuk’s 50th Birthday party',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Producing - Music Arrangement - Sound Design - Mixing',
        bgImg: courchevelProjImg,
        extraMedia: [
            {
                type: 'video',
                data: { src: 'https://player.vimeo.com/video/136457217' },
            },
        ],
        hideLogo: true,
    },
    {
        id: 26,
        title: 'Cirque du Soleil (Iris) and Danny Elfman',
        altTitle: 'Iris',
        year: 2010,
        location: 'Canada and United States',
        subtitle:
            'Danny Elfman assistant with Thierry Angers in Iris, a Cirque du Soleil show in Los Angeles',
        detailedSubtitle: undefined,
        bgImg: irisImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/234518821',
                },
            },
        ],
        hideLogo: true,
    },
    {
        id: 27,
        title: 'Michael Easton',
        year: 2017,
        location: 'Los Angeles, USA',
        subtitle: 'First Strike Butcher Knife Short Film',
        detailedSubtitle: undefined,
        bgImg: michaelEastonProjImg,
        categoriesText:
            'Music Composition - Music Producing - Music Arrangement - Mixing',
    },
    {
        id: 74,
        title: 'Prince Edward Island - Charlottetown Summerfest',
        altTitle: 'PEI Summerfest',
        year: 2010,
        location: 'Prince Edward Island, Canada',
        subtitle: 'Prince Edward Island - Charlottetown Summerfest',
        detailedSubtitle: undefined,
        categoriesText: 'Music Producing - Music Arrangement - Mixing',
        bgImg: peiImg,
    },
    {
        id: 19,
        title: 'Canadian Space Agency',
        year: 1999,
        location: 'Montreal, Canada',
        subtitle: 'Y2K promotional DVD of the agency',
        detailedSubtitle: undefined,
        categoriesText:
            'Music Composition - Music Producing - Sound Design - Mixing ',
        bgImg: csaProjImg,
        extraMedia: [
            {
                type: 'video',
                data: {
                    src: 'https://player.vimeo.com/video/175960386',
                },
            },
        ],
        hideLogo: true,
    },
];
